import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import {
  Row,
  Col,
} from 'antd';

import {
  PageSection,
  messageError,
  ComponentLoader,
  messageSuccess,
} from '@deltaohm/ant-components';

import {
  SOUND_SESSION_UPDATE_MUTATION,
} from '../queries';

import { extractGraphQLErrors } from '../../utils/graphql';

import { ErrorList } from '../../generics';

import {
  SoundSessionForm,
} from '../components';

const SoundSessionPropertyTab = (props) => {
  const {
    workspaceId,
    soundSession,
  } = props;

  const { t } = useTranslation();

  const [
    soundSessionUpdateMutationAction,
    {
      loading,
      error,
    },
  ] = useMutation(SOUND_SESSION_UPDATE_MUTATION);

  React.useEffect(() => {
    if (error) {
      const errors = extractGraphQLErrors(error, t);
      messageError({
        content: <ErrorList errors={errors} />,
      });
    }
  }, [error, t]);

  const handleFormSubmit = async (data) => {
    try {
      await soundSessionUpdateMutationAction({
        variables: {
          input: {
            workspaceId,
            id: soundSession.id,
            ...data,
          },
        },
      });
      messageSuccess(t('common.successMessage'));
    }
    // eslint-disable-next-line no-empty
    catch (e) { }
  };

  return (
    <PageSection
      title={t('soundSessions.propertyTab.title')}
    >
      <Row>
        <Col xs={24}>
          <ComponentLoader
            message={t('common.loading')}
            loading={loading}
          >
            <SoundSessionForm
              soundSession={soundSession}
              onFormSubmit={handleFormSubmit}
            />
          </ComponentLoader>
        </Col>
      </Row>
    </PageSection>
  );
};

const propTypes = {
  workspaceId: PropTypes.string.isRequired,
  soundSession: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    reference: PropTypes.string,
    note: PropTypes.string,
    source: PropTypes.string.isRequired,
  }).isRequired,
};

SoundSessionPropertyTab.propTypes = propTypes;

export default SoundSessionPropertyTab;
